import React from 'react';
import { render } from 'react-dom';

import { getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import { formatDate } from '../react/BookingFieldset/helpers';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import PapBookingSummary from '../react/PapBookingSummary';

export default class PapBookingSummaryRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, loadApi, title } = this.context.dataset;
    if (!apiUrl || !model || !loadApi) throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    jsonGet(loadApi, null, (response) => {
      if (response.errorCode) {
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        PapBookingSummaryRender.renderMain(response, labels, apiUrl, title),
        this.context
      );
    });

    return render(
      PapBookingSummaryRender.renderMain(undefined, labels, apiUrl, title),
      this.context
    );
  }

  static renderMain(papBookingSummaryData, labels, apiUrl, title) {
    const data = papBookingSummaryData;

    if (data) {
      // Format Lead Party Member Date of Birth
      if (data.paymentUser.dateOfBirth) {
        data.paymentUser.dateOfBirth = formatDate(data.paymentUser.dateOfBirth);
      }
    }

    return (
      <>
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {data ? <PapBookingSummary data={data} labels={labels} apiURL={apiUrl} /> : <Loading />}
      </>
    );
  }
}
